// Conservative CPU Float64 whole-tile zero proof; copied from the worker-only prototype.
export function isAnalyticZeroTile(params) {
  const { xRange, yRange, canvasWidth, canvasHeight,
    startX, startY, regionWidth, regionHeight } = params;
  if (params?.colorParams?.juliaC || params?.juliaC || params?.colorParams?.newtonC || params?.newtonC) return false;
  if (!Number.isInteger(canvasWidth) || !Number.isInteger(canvasHeight) ||
      !Number.isInteger(startX) || !Number.isInteger(startY) ||
      !Number.isInteger(regionWidth) || !Number.isInteger(regionHeight) ||
      canvasWidth < 1 || canvasHeight < 1 || canvasWidth > 16384 || canvasHeight > 16384 ||
      regionWidth < 1 || regionHeight < 1 || startX < 0 || startY < 0 ||
      startX + regionWidth > canvasWidth || startY + regionHeight > canvasHeight ||
      !Array.isArray(xRange) || !Array.isArray(yRange) ||
      xRange.length !== 2 || yRange.length !== 2) return false;
  const xMin = xRange[0], xMax = xRange[1];
  const yMin = yRange[0], yMax = yRange[1];
  if (!(Number.isFinite(xMin) && Number.isFinite(xMax) &&
        Number.isFinite(yMin) && Number.isFinite(yMax) &&
        xMin >= -4 && xMax <= 4 && yMin >= -4 && yMax <= 4 &&
        xMax > xMin && yMax > yMin &&
        xMin <= 0.25 && xMax >= -1.25 &&
        yMin <= 0.5 && yMax >= -0.5)) return false;
  const xScale = (xMax - xMin) / canvasWidth;
  const yScale = (yMax - yMin) / canvasHeight;
  if (!(Number.isFinite(xScale) && Number.isFinite(yScale) &&
        xScale > 0 && yScale > 0)) return false;
  const left = xMin + (startX + 0.5) * xScale;
  const right = xMin + (startX + regionWidth - 0.5) * xScale;
  const top = yMin + (startY + 0.5) * yScale;
  const bottom = yMin + (startY + regionHeight - 0.5) * yScale;
  if (!(Number.isFinite(left) && Number.isFinite(right) &&
        Number.isFinite(top) && Number.isFinite(bottom))) return false;
  const maxY = Math.max(Math.abs(top), Math.abs(bottom));
  const cardioidX = Math.max(Math.abs(left + 0.25), Math.abs(right + 0.25));
  if (cardioidX * cardioidX + maxY * maxY < 0.25 - 2 ** -40) return true;
  const bulbX = Math.max(Math.abs(left + 1), Math.abs(right + 1));
  return bulbX * bulbX + maxY * maxY < 0.0625 - 2 ** -40;
}
